import { Component, Host, h, Prop, Event, EventEmitter, Listen } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';

import { SizeType } from '../../types';

@Component({
  tag: 'anchor-menu-item',
  styleUrl: 'menu-item.scss',
  shadow: true,
})
export class MenuItem {
  /**
   *  Give this instance of menu-item a custom ID, or keep the default.
   */
  @Prop({}) uuid: string = uuidv4();

  /**
   * tabindex is a reserved name so we use tabi which will apply the tabindex attribute
   * Default value should work fine so don't change this unless you have a really good reason to. Set to -1 to disable tabbing.
   */
  @Prop({
    attribute: 'tab-index',
  })
  tabi: number = 0;

  /**
   * Where should the user go, when clicking on the menu-item.
   */
  @Prop() url = undefined;

  /**
   * Whether to display the link in compact mode.
   */
  @Prop() compact: boolean = false;

  /**
   * Whether to display the link with a border.
   */
  @Prop() box: boolean = false;

  /**
   * Event dispatched when link-item is clicked
   * `{querySelecter}.addEventListener('clicked', ({event}) => {console.log('clicked:', event)})`
   */
  @Event() clicked: EventEmitter<{ url: string }>;

  private onClicked = () => {
    this.clicked.emit(this.url);
  };

  private onItemKeyUp(e: KeyboardEvent) {
    if (e.code === 'Space' || e.code === 'Enter') {
      this.onClicked();
    }
  }

  @Listen('click')
  handleClick(_e: PointerEvent) {
    this.clicked.emit(this.url);
  }

  render() {
    const iconSize = (this.compact ? 'small' : 'medium') as SizeType;
    return (
      <Host>
        <a
          href={this.url}
          class={{
            'anchor-c-menu-item': true,
            'compact': this.compact,
            'box': this.box,
          }}
          id={this.uuid}
          onKeyUp={e => this.onItemKeyUp(e)}
          tabindex={this.tabi}
        >
          <slot name="icon"></slot>
          <slot name="text"></slot>
          <anchor-icon name="chevron-right" size={iconSize} stroke={2} />
        </a>
      </Host>
    );
  }
}
